import {
  makeStyles,
  mergeClasses,
  shorthands,
} from "@fluentui/react-components";
import type { AppPreviewGalleryButtonDisplayState } from "./AppPreviewGalleryButtonDisplay.types";
import { customTokens } from "@1js/acui-theme";
// eslint-disable-next-line no-restricted-imports
import { HighContrastSelector } from "@1js/acui-common/lib/styling/next/commonStyles.styles";

const useButtonDisplayRootStyles = makeStyles({
  base: {
    overflow: "hidden",
    display: "flex",
    ...shorthands.border(
      customTokens.strokeWidthThin,
      "solid",
      customTokens.colorNeutralStroke1
    ),

    borderRadius: customTokens.borderRadiusMedium,
    // The right of this component is where the menu button is located, setting the border Color
    // to none so just the menu button can display the border and still there is symmetry on left and right sides
    borderRightColor: customTokens.colorTransparentBackground,
    borderRightWidth: customTokens.spacingVerticalNone,

    borderTopRightRadius: "0px",
    borderBottomRightRadius: "0px",
    [`${HighContrastSelector}`]: {
      ...shorthands.border(
        customTokens.strokeWidthThin,
        "solid",
        customTokens.colorNeutralForeground1
      ),
      borderRightColor: "transparent",
      borderRightWidth: customTokens.spacingVerticalNone,
    },
  },
});

const useStackStyles = makeStyles({
  root: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    width: "444px",
  },
});

export const useAppPreviewGalleryButtonDisplayStyles = (
  state: AppPreviewGalleryButtonDisplayState
): AppPreviewGalleryButtonDisplayState => {
  const rootStyles = useButtonDisplayRootStyles();
  const stackStyles = useStackStyles();

  state.root.className = mergeClasses(rootStyles.base, state.root.className);

  if (state.stackWrapper) {
    state.stackWrapper.className = mergeClasses(
      stackStyles.root,
      state.stackWrapper.className
    );
  }

  return state;
};
